import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminSuppliesPage } from './admin-supplies';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    AdminSuppliesPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminSuppliesPage),
    DirectivesModule  
  ],
})
export class AdminSuppliesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-supplies/admin-supplies.module.ts